// extracted by mini-css-extract-plugin
export default {"banner1":"banner1_banner1__5GeRi","block":"banner1_block__883iL","animation":"banner1_animation__7Se9g","icon":"banner1_icon__9SiMJ","text":"banner1_text__5rlzs"};